import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ModalHeader, Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar'
import { API_URL } from '../../../config';
import right from '../../images/right.png'


const EditTechSupport = () => {

  const [data, setData] = useState([])
  const firstname = useRef()
  const lastname = useRef()
  const telephone = useRef()
  const email = useRef()
  const address = useRef()
  const address1 = useRef()
  const city = useRef()
  const zipcode = useRef()
  const stateref = useRef()
  const countryref = useRef()
  const password = useRef()
  const business = useRef()
  const [state, setState] = useState([]);
  const [country, setCountry] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [fillallfieldmodal, setFillallfieldModal] = useState(false);
  const fillallfieldtoggleModal = () => setFillallfieldModal(!fillallfieldmodal);
  const [emailalreadyExitmodal, setEmailalreadyExitmodal] = useState(false);
  const EmailalreadyExittoggleModal = () => setEmailalreadyExitmodal(!emailalreadyExitmodal);
  const [error, setError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const [title, setTitle] = useState("");

  const { id } = useParams();

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  useEffect(() => {
    getCountry();
    getdistributorbyid();
    checkTitle();
  }, [id])


  const checkTitle = () => {
    if (localStorage.getItem('uid') == id) {
      setTitle("Edit Profile")
    } else {
      setTitle("Edit Distributor")
    }
  }


  const getdistributorbyid = () => {
    setData('')
    fetch(API_URL + "/get/distributer/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setData(resp.data[0]);
          getState(resp.data[0].country)

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

  const getCountry = () => {
    fetch(API_URL + "/countries",
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setCountry(resp.countries);

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

  const getState = (countryid) => {



    fetch(API_URL + "/states?country_id=" + countryid,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',

        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setState(resp.states);

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

  const handleCountryUpdate = (e) => {
    getState(countryref.current.value)

  }

  const updateProfile = () => {
    
    setLoader(true)
    const str1 = firstname.current.value
    const capfname = str1.charAt(0).toUpperCase() + str1.slice(1);
    const str2 = lastname.current.value
    const caplname = str2.charAt(0).toUpperCase() + str2.slice(1);




    if (firstname.current.value == "" || lastname.current.value == "" || telephone.current.value == "" || email.current.value == "" || password.current.value == "" ) {
      fillallfieldtoggleModal();
      setLoader(false)

      return false;
    } else {
      setLoader(true)
    }


    let data = {};
    data['user_type'] = 8;
    data['firstname'] = capfname;
    data['lastname'] = caplname;
    data['telephone'] = telephone.current.value == null ? "NA" : telephone.current.value;
    data['email'] = email.current.value;
    data['password'] = password.current.value;
    // data['business'] = business.current.value||"";
    data['address'] = address.current.value||"";
    data['address2'] = address1.current.value||"";
    data['zipcode'] = zipcode.current.value||"";
    data['city'] = city.current.value||"";
    data['state'] = stateref.current.value||"";
    data['country'] = countryref.current.value||"";


    function isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }
    if (!isValidEmail(email.current.value)) {
      setError(true);
      setLoader(false)
      return false;
    } else {
      setError(false);
    }



    fetch(API_URL + "/update/distributer/profile/by/" + id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          successToggleModal();
          setLoader(false)

        });
      }
      else if (response.status == 400) {
        setLoader(false)
        EmailalreadyExittoggleModal();
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }
    })

  }
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleEmail = () => {

    if (!isValidEmail(email.current.value)) {
      setError(true);
    } else {
      setError(false);
    }
  }

  // const handleTelephoneChange = ()=>{


  //   const regex = /^[0-9-]*$/;

  //   // Check if the input matches the regular expression
  //   if (regex.test(telephone.current?.value)) {
     
  //   }else{
  //     alert("incorrect")
  //   }
  // }


  const handleKeyPress = (event) => {
    // Prevent the user from typing alphabetic characters
    const key = event.key;
    // const regex = /^[0-9-.]$/;
    const regex = /^[\d().+-]+$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  };

  const navigate = useNavigate()

  const handleGoBack = () => {
    if (localStorage.getItem('uid') == id) {
      navigate('/');
    } else {
      navigate('/distributors');
    }
  }

  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section " >

          <div className="head-listing head-listingb">
            <h3>{title}</h3>
          </div>
          <div className='right-section-box'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>First Name* </label>
                  <input type="text" defaultValue={data?.firstname} ref={firstname} className='client-input' placeholder='Enter first name' />
                </div>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Last Name*</label>
                  <input type="text" defaultValue={data?.lastname} ref={lastname} className='client-input' placeholder='Enter last name' /></div>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Telephone*</label>
                  <input
                    type="text"
                    defaultValue={data?.telephone}
                    ref={telephone}
                    className='client-input'
                    onKeyPress={handleKeyPress}
                    placeholder='Enter a telephone'
                    
                  />
                  {/* {
                    error && <p className='validemail'>Invalid Telephone Number</p>
                  } */}
                </div>
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Email*</label>
                  <input type="email" defaultValue={data?.email} onChange={handleEmail} ref={email} className='client-input' placeholder='Enter an email' />
                  {
                    error && <p className='validemail'>Invalid Email</p>
                  }
                </div>
                <div className='form-group col-lg-4 no-padding'>
                  <label className='control-label relativeinput'>
                    Password*</label>
                  <input type={passwordShown ? "text" : "password"} defaultValue={data?.password} ref={password} className='client-input' placeholder='Enter a password' />
                  {
                    passwordShown ? <i className="fa fa-eye-slash pass-eye3" aria-hidden="true" onClick={togglePasswordVisiblity}></i> : <i className="fa fa-eye pass-eye3" aria-hidden="true" onClick={togglePasswordVisiblity}></i>
                  }
                </div>
                {/* <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Business Name*</label>
                  <input type="text" defaultValue={data?.business} ref={business} className='client-input' placeholder='Enter business' /></div> */}
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                    Address</label>
                  <textarea type="textarea" rows='1' cols='52' name='address' defaultValue={data?.address} ref={address} className='client-input' placeholder='Enter physical address 1' /></div>
                <div className='form-group col-lg-12 no-padding'>
                  <textarea type="textarea" rows='1' cols='52' name='address' defaultValue={data?.address2} ref={address1} className='client-input' placeholder='Enter physical address 2' /></div>
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-3 no-padding'>
                  <label className=' control-label'>
                    Country</label>
                  <select onChange={handleCountryUpdate} defaultValue={data?.country} ref={countryref} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Country</option>
                    {
                      country.length > 0 && country.map((val, i) => {
                        return (

                          <option selected={data?.country == val.id ? true : false} value={val.id}>{val.name}</option>
                        )
                      })
                    }
                  </select></div>
                <div className='form-group col-lg-3 no-padding'>
                  <label className=' control-label'> State</label>
                  <select className='client-input' ref={stateref} placeholder='Choose States/Province'>
                    <option value="">Select State</option>

                    {
                      state.length > 0 && state.map((val, i) => {

                        return (
                          <option selected={val.id == data?.state ? true : false} value={val.id}>{val.name}</option>
                        )
                      })
                    }
                  </select></div>
                <div className='form-group col-lg-3 no-padding'>
                  <label className=' control-label'>
                    City</label>
                  <input type="text" defaultValue={data?.city} ref={city} className='client-input' placeholder='Enter city' /></div>
                <div className='form-group col-lg-3 no-padding'>
                  <label className='control-label'>Postal Code</label>
                  <input type="text" defaultValue={data?.zipcode} ref={zipcode} className='client-input' placeholder='Enter postal code' />
                </div>
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="submit" className='btn btn-primary_d' onClick={updateProfile}>Update
                    {
                      Loader &&
                      <div id="loader"></div>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={fillallfieldmodal} toggle={fillallfieldtoggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={fillallfieldtoggleModal}><span className="ml-1 roititle font-weight-bold">Error</span></ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Please fill all required field</p>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={emailalreadyExitmodal} toggle={EmailalreadyExittoggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={EmailalreadyExittoggleModal}><span className="ml-1 roititle font-weight-bold">Error</span></ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Tech Support already exist with this email</p>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>Updated!</h4>
            <p>Tech Support Profile has been updated successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default EditTechSupport;
